import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { t } from '../i18n';

/**
 * Impressum und Datenschutz (Auftrag: aus den Aisterpiece-Rechtstexten abgeleitet und für
 * WerkDelta angepasst). Öffentlich erreichbar (auch ohne Anmeldung); Texte über die i18n-Schicht.
 */

function LegalShell({ children }: { children: ReactNode }) {
  return (
    <div className="legal-seite" style={{ maxWidth: '46rem', margin: '0 auto', padding: '2rem 1.25rem', lineHeight: 1.6 }}>
      <Link to="/" style={{ fontWeight: 700, fontSize: '1.1rem', textDecoration: 'none' }}>
        {t('app.name')}
      </Link>
      <div style={{ marginTop: '1.5rem' }}>{children}</div>
      <p className="meta" style={{ marginTop: '1.5rem' }}>{t('legal.langNote')}</p>
      <nav aria-label="Rechtliches" style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', marginTop: '0.75rem' }}>
        <Link to="/impressum">{t('app.impressumLink')}</Link>
        <Link to="/nutzungsbedingungen">{t('app.nutzungLink')}</Link>
        <Link to="/datenschutz">{t('app.datenschutzLink')}</Link>
        <Link to="/">{t('legal.backToApp')}</Link>
      </nav>
    </div>
  );
}

function Section({ prefix, id, pre }: { prefix: string; id: string; pre?: boolean }) {
  return (
    <section>
      <h2>{t(`${prefix}.${id}.title`)}</h2>
      <p style={pre ? { whiteSpace: 'pre-line' } : undefined}>{t(`${prefix}.${id}.body`)}</p>
    </section>
  );
}

function Disclaimer() {
  return (
    <div className="hinweis" style={{ marginTop: '1.75rem' }}>
      <strong>{t('legal.disclaimerTitle')}</strong>
      <br />
      {t('legal.disclaimer')}
    </div>
  );
}

export function ImpressumPage() {
  const p = 'legal.impressum';
  return (
    <LegalShell>
      <h1>{t(`${p}.title`)}</h1>
      <p className="meta">{t(`${p}.updated`)}</p>
      <Section prefix={p} id="betreiber" pre />
      <section>
        <h2>{t(`${p}.kontakt.title`)}</h2>
        <p>
          E-Mail: <a href={`mailto:${t(`${p}.kontakt.email`)}`}>{t(`${p}.kontakt.email`)}</a>
        </p>
      </section>
      <Section prefix={p} id="hr" />
      <Section prefix={p} id="verantwortlich" />
      <Section prefix={p} id="charakter" />
      <Section prefix={p} id="haftungNutzung" pre />
      <Section prefix={p} id="haftungInhalte" />
      <Section prefix={p} id="haftungLinks" />
      <Section prefix={p} id="urheberrecht" />
      <Disclaimer />
    </LegalShell>
  );
}

const NUTZUNG_SECTIONS = [
  'geltung',
  'charakter',
  'verantwortung',
  'haftung',
  'pflichten',
  'verfuegbarkeit',
  'daten',
  'aenderungen',
  'recht',
];

export function NutzungsbedingungenPage() {
  const p = 'legal.nutzung';
  return (
    <LegalShell>
      <h1>{t(`${p}.title`)}</h1>
      <p className="meta">{t(`${p}.updated`)}</p>
      {NUTZUNG_SECTIONS.map((id) => (
        <Section key={id} prefix={p} id={id} />
      ))}
      <Disclaimer />
    </LegalShell>
  );
}

const DATENSCHUTZ_SECTIONS = [
  'verantwortlich',
  'rolle',
  'konten',
  'session',
  'loginSicherheit',
  'falldaten',
  'audit',
  'hosting',
  'dienste',
  'bekanntgabe',
  'aufbewahrung',
  'rechte',
  'datensicherheit',
  'aenderungen',
];

export function DatenschutzPage() {
  const p = 'legal.datenschutz';
  return (
    <LegalShell>
      <h1>{t(`${p}.title`)}</h1>
      <p className="meta">{t(`${p}.updated`)}</p>
      {DATENSCHUTZ_SECTIONS.map((id) => (
        <Section key={id} prefix={p} id={id} />
      ))}
      <Disclaimer />
    </LegalShell>
  );
}
